module.exports = __webpack_public_path__ + "img/RU.562474ef.svg";